import { takeEvery, select } from 'redux-saga/effects'
import { LOCATION_CHANGE } from 'connected-react-router'

import { getCompanyName } from '../account/selectors'
import { currentUser } from '../auth/selectors'

function * locationChangeSaga (action) {
  const { pathname } = action.payload
  const { userId, email } = yield select(currentUser)
  const accountName = yield select(getCompanyName)
  window.gtag('config', process.env.GA_TRACKING_ID, {
    linker: {
      domains: [
        'control.paymentsos.com',
        'paymentsos.com',
        'developers.paymentsos.com'
      ]
    },
    page_path: pathname,
    dimension1: accountName,
    dimension2: userId,
    dimension3: email
  })
}
export function * analyticsSaga () {
  yield takeEvery(LOCATION_CHANGE, locationChangeSaga)
}
